/**
 * `/teacher/settings` — display-only settings for Sprint 1.
 *
 * Mock LMS connection state, notification preferences, and the dev-only
 * sign-out are all that ship here. Real LMS connect / OAuth / write-back
 * configuration is intentionally absent.
 */

import { useApiClient } from '../../api/ApiClientProvider';
import { useFetch } from '../../api/useFetch';
import { useSession } from '../../auth/SessionProvider';
import { ErrorState, LoadingState } from '../../components/States';

export function Settings() {
  const client = useApiClient();
  const { session, signOut } = useSession();
  const token = session?.token ?? '';
  const state = useFetch(() => client.getSettings(token), [client, token]);

  if (state.status === 'loading') {
    return <LoadingState label="Loading settings…" />;
  }
  if (state.status === 'error') {
    return <ErrorState error={state.error} />;
  }

  const settings = state.data;

  return (
    <section className="page" data-testid="teacher-settings">
      <header className="page__header">
        <h1>Settings</h1>
        <p className="muted">
          Mock data only. Real Canvas connection, billing, and tenant
          configuration land in a later sprint.
        </p>
      </header>

      <dl className="kv">
        <dt>Tenant</dt>
        <dd>
          <code>{settings.tenantId}</code>
        </dd>
        <dt>LMS provider</dt>
        <dd>
          Mock LMS Connected · Real Canvas connection is disabled in local MVP.
        </dd>
        <dt>Signed in as</dt>
        <dd>
          <code>{session?.principal.userId}</code> ·{' '}
          <span className="badge">{session?.principal.role}</span>
        </dd>
        <dt>Notify when grading draft is ready</dt>
        <dd>{settings.notifications.gradingDraftReady ? 'On' : 'Off'}</dd>
        <dt>Notify when courseware draft is ready</dt>
        <dd>{settings.notifications.coursewareDraftReady ? 'On' : 'Off'}</dd>
      </dl>

      <div className="actions">
        <button type="button" className="btn btn--ghost" onClick={signOut}>
          Sign out
        </button>
      </div>
    </section>
  );
}
